import type { viewportSnapshotCaptureSchema } from "schemas/agentCoordinatorApi";
import type { z } from "zod";
import type { RequestFn } from "./request";

export type ViewportSnapshotCapture = z.infer<
  typeof viewportSnapshotCaptureSchema
>;

export function createViewportSnapshotsClient({
  request,
}: {
  request: RequestFn;
}) {
  return {
    upload: ({
      projectId,
      sessionId,
      ...capture
    }: { projectId: string; sessionId: string } & ViewportSnapshotCapture) => {
      return request<{ accepted: boolean }>({
        method: "POST",
        path: `/api/v1/projects/${projectId}/sessions/${sessionId}/viewport-snapshot`,
        body: capture,
      });
    },
  };
}
